import React from 'react';
import { Container } from '@si-armes/dsfr-react';

const DonneesPersonnelles = () => {
    return (
        <Container fluid={false}>
            <h1>Traitement des donnees à caractère personnel</h1>
            <h2>Traçabilité et profilage</h2>
            <p className="text-justify" role="text">
                Le site internet du Système d'information sur les armes utilise des cookies
                uniquement pour la résolution du terminal qui se connecte au site web.
            </p>
            <h2>Droit d&apos;accès, de modification, de suppression et d&apos;opposition</h2>
            <p className="text-justify" role="text">
                Pour exercer vos droits d'accès, de rectification, de limitation et d'effacement
                (sous certaines conditions, art.17 du RGPD), vous devez utiliser le{' '}
                <a
                    href="/nous-contacter"
                    title="accéder au formulaire de contact dans un nouvel onglet"
                    target="_blank"
                >
                    formulaire de contact
                </a>{' '}
                en joignant une copie de votre pièce d’identité.
            </p>

            <p className="text-justify" role="text">
                Ce traitement est contrôlé par le délégué ministériel à la protection des données du
                ministère de l'intérieur (Délégué ministériel à la protection des données -
                Ministère de l'intérieur - Place Beauvau - 75800 Paris Cedex 08).
            </p>

            <p className="text-justify" role="text">
                Vous pouvez aussi déposer une réclamation auprès de la Commission nationale de
                l'informatique et des libertés (CNIL - 3 place de Fontenoy - TSA 80715 - 75334 Paris
                Cedex 07).
            </p>
        </Container>
    );
};

export default DonneesPersonnelles;
